import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { invalidateResource } from "kea-resource";

import { columnas } from "./columnas";

type Entity = models.ManifiestosCargaDescargaRADView;
export interface Props {
    value: Entity[];
    readonly?: boolean;
}

/**
* Listado de CargaDescargaCajaRutaDto
*/
class CargaDescargaCajaRutaDtoListNoRx extends React.PureComponent<Props> {
    render() {
        const cols = columnas();
        return (
            <div>
                <kea.Grid2 items={this.props.value} columnas={cols} />
            </div>
        );
    }
}
export const CargaDescargaCajaRutaDtoList = kea.mapProps(componentToRx(CargaDescargaCajaRutaDtoListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/consultaMovimientosCarga/list/cargasdescargas/list.tsx